import { Component } from '@angular/core';

/**
 * Top accent stripe in the workspace chrome.
 *
 * v1: single fixed CDP brand color across all companies.
 * Future: per-company accent (would either parse from BrandConfiguration.VisualIdentityGuidelines
 * or get a dedicated AccentColor column added in a later schema migration).
 */
@Component({
    standalone: false,
    selector: 'mkt-ws-brand-stripe',
    template: `<div class="bs"></div>`,
    styles: [`
        :host { display: block; }
        .bs { height: 3px; background: var(--mj-brand-primary, #6366f1); }
    `]
})
export class BrandStripeComponent {}
